
  // @ts-nocheck
  (function () { // make vuetify dialogs movable
      const d = {};
      document.addEventListener("mousedown", e => {
          const closestDialog = e.target.closest(".v-dialog.v-dialog--active");
          if (e.button === 0 && closestDialog != null && e.target.classList.contains("v-card__title")) { // element which can be used to move element
              d.el = closestDialog; // element which should be moved
              d.mouseStartX = e.clientX;
              d.mouseStartY = e.clientY;
              d.elStartX = d.el.getBoundingClientRect().left;
              d.elStartY = d.el.getBoundingClientRect().top;
              d.el.style.position = "fixed";
              d.el.style.margin = 0;
              d.oldTransition = d.el.style.transition;
              d.el.style.transition = "none"
          }
      });
      document.addEventListener("mousemove", e => {
          if (d.el === undefined) return;
          d.el.style.left = Math.min(
              Math.max(d.elStartX + e.clientX - d.mouseStartX, 0),
              window.innerWidth - d.el.getBoundingClientRect().width
          ) + "px";
          d.el.style.top = Math.min(
              Math.max(d.elStartY + e.clientY - d.mouseStartY, 0),
              window.innerHeight - d.el.getBoundingClientRect().height
          ) + "px";
      });
      document.addEventListener("mouseup", () => {
          if (d.el === undefined) return;
          d.el.style.transition = d.oldTransition;
          d.el = undefined
      });
      setInterval(() => { // prevent out of bounds
          const dialog = document.querySelector(".v-dialog.v-dialog--active");
          if (dialog === null) return;
          dialog.style.left = Math.min(parseInt(dialog.style.left), window.innerWidth - dialog.getBoundingClientRect().width) + "px";
          dialog.style.top = Math.min(parseInt(dialog.style.top), window.innerHeight - dialog.getBoundingClientRect().height) + "px";
      }, 100);
  })();
  // @ts-check

  import { Vue, Prop, PropSync, Component, Watch } from 'vue-property-decorator'
  import GeneralView from '../../components/ViewTypes/GeneralView.vue'
  import BridgeMaintenanceCostView from '../../components/ViewTypes/BridgeMaintenanceCostView.vue'
  import BridgeMaintenanceLogView from '../../components/ViewTypes/BridgeMaintenanceLogView.vue'
  import BridgeInspectionReportsView from '../../components/ViewTypes/BridgeInspectionReportsView.vue'
  import BridgePlansView from '../../components/ViewTypes/BridgePlansView.vue'
  import BridgeDocumentsView from '../../components/ViewTypes/BridgeDocumentsView.vue'
  import BridgePhotosView from '../../components/ViewTypes/BridgePhotosView.vue'
  import BridgePermitRatingsView from '../../components/ViewTypes/BridgePermitRatingsView.vue'
  import BridgeSpecialItemsView from '../../components/ViewTypes/BridgeSpecialItemsView.vue'
  import { Item, ItemData } from '../../store/types/bridge'

  @Component({
    components: {
      GeneralView,
      BridgeMaintenanceCostView,
      BridgeMaintenanceLogView,
      BridgePlansView,
      BridgeDocumentsView,
      BridgePhotosView,
      BridgeInspectionReportsView,
      BridgePermitRatingsView,
      BridgeSpecialItemsView
    }
  })

  export default class ViewDetails extends Vue  {
    //Prop
    @Prop() readonly item!: Item
    @PropSync('viewDialog', { type: Boolean }) syncViewDialog!: boolean

    //Data
    tab = 0

    //Watch
    @Watch('syncViewDialog')
    onDialogChanged(val: boolean) {
      if(val) {
        this.$store.dispatch('bridge/getGeneralInfo', { id: this.item.id })
      }
    }

    @Watch('tab')
    onTabChanged(val: number) {
      if(val == 0 && this.syncViewDialog) {
        this.$store.dispatch('bridge/getGeneralInfo', { id: this.item.id })
      }
      if(val == 1) {
        this.$store.dispatch('bridge/getMaintenanceCosts', { id: this.item.id })
      }
      if(val == 2) {
        this.$store.dispatch('bridge/getMaintenanceLogs', { id: this.item.id })
      }
      if(val == 3) {
        this.$store.dispatch('bridge/getBridgePlans', { id: this.item.id })
      }
      if(val == 4) {
        this.$store.dispatch('bridge/getBridgeDocuments', { id: this.item.id })
      }
      if(val == 5) {
        this.$store.dispatch('bridge/getBridgePhotos', { id: this.item.id })
      }
      if(val == 6) {
        this.$store.dispatch('bridge/getBridgeInspectionReports', { id: this.item.id })
      }
      if(val == 7) {
        this.$store.dispatch('bridge/getBridgePermitRatings', { id: this.item.id })
      }
      if(val == 8) {
        this.$store.dispatch('bridge/getBridgeSpecialItems', { id: this.item.id })
      }
    }

    //Methods
    public close(): void {
      this.$emit('closeView')
      this.$store.commit('bridge/setMsg', "")
      this.syncViewDialog = false
      this.tab = 0
    }
    public changeTab(tab: number): void {
      this.tab = tab
    }
    public resetMetaData(): void {
      this.$store.commit('bridge/setMsg', "")
    }
    //Emits


    //Computed
    get getErrors(): Array<string> {
      return this.$store.getters['bridge/getErrors']
    }

    get getPreparedItem(): ItemData {
      return this.$store.getters['bridge/getPreparedItem']
    }

  }
